import React, { Component } from "react";
import { FiSmile } from "react-icons/fi";
import { ContactContainer } from "./container";
import ExternalLinks from "./external_links";
import InternalLinks from "./internal_links";

class Contact extends Component {

  render() {
    return (
        <div style={{"margin":"50px 0px 50px", "textAlign": "center"}} id="/contact">

            <InternalLinks />
            <br />
            <ExternalLinks />

            <br /><br />

            <div className="reveal">
              <ContactContainer text="Looking to discuss about" />
              <ContactContainer text="data science/analytics topics," />
              <ContactContainer text="or other professional topics?" />
            </div>

            <div className="reveal delay-1">
              <p style={{"color": "white", "textAlign": "center", "font-family": "Fuzzy Bubbles"}}>Let's connect on <a className="button" href="https://www.linkedin.com/in/leowginee/" target="_blank"  rel="noopener noreferrer">LinkedIn</a></p>
              <FiSmile size={40} color="white" />
            </div>

            <div className="reveal delay-2">
              <ContactContainer text="- Gin Ee (not Genie)" />
            </div>

        </div>
    );
  }

}

export default Contact;